export class FrontBanner {

    constructor() {
       let frontBanner = document.querySelector('.front-banner');
       this.banner = frontBanner;

       if(frontBanner) {
           let stateWrap = frontBanner.querySelector('.state-wrap'),
               downArrow = frontBanner.querySelector('.down-arrow');

           this.stateFinished = stateWrap.querySelector('.finished');
           this.stateRemain = stateWrap.querySelector('.remain');
           this.banners = frontBanner.querySelectorAll('.panel');
           this.initialiseBanners();

           downArrow.addEventListener('click', e => this.slideDown());
       }
    }

    initialiseBanners(){
        this.currentBanner = 0;
        this.showBanner(0);

        if(this.banners.length > 1) {
            this.startLoop();
            this.initialiseStateIndicators();
        }

    }

    initialiseStateIndicators(){
        var i = 0;

        while(i < this.banners.length) {
            this.addStateIndicator(true, i, i === 0);
            i++;
        }

    }

    addStateIndicator(remain, key, active = false, before = false, shrinkStart = false) {
        let self = this;

        var indicator = document.createElement("li");
        indicator.setAttribute('data-banner', key);
        indicator.addEventListener('click', e => this.toggleTowardsBanner(key));

        if(active) {
            indicator.classList.add('active');
        }

        if(shrinkStart) {
            indicator.classList.add('shrink');
            setTimeout(function(){
                indicator.classList.remove('shrink');
            }, 30);
        }

        if(remain) {
            if(before) {
                this.stateRemain.insertBefore(indicator, this.stateRemain.firstChild);
            } else {
                this.stateRemain.appendChild(indicator);
            }
        } else {
            this.stateFinished.appendChild(indicator);
        }

    }
    
    toggleTowardsBanner(key) {
    	
    	this.currentBanner = key;
	
        let active = this.stateRemain.querySelector('.active');

        if(active && active.getAttribute('data-banner') == key) {
            return false;
        }

        this.showBanner(key);

        this.removeInactive(0);
        this.removeActive(true);
        this.removeRemain(0);
        
        var i = 0;
        while(i < this.banners.length) {
           if (i < this.currentBanner) {
           	console.log('add inactive ');
           	console.log(i);
              this.addInactive(i);
           } else if (i == this.currentBanner) {
           	console.log('add highlighted active ');
           	console.log(i);
           	this.addStateIndicator(true, i, true, false, true);
           } else {
           	console.log('add active ');
           	console.log(i);
              this.addStateIndicator(true, i, false, false, true);
           }
           i++;
        }

    }

    toggleBanner(key) {

        let active = this.stateRemain.querySelector('.active');

        if(active && active.getAttribute('data-banner') == key) {
            return false;
        }

        this.showBanner(key);
        this.removeInactive(key);
        this.removeActive();

        let remaining = this.stateRemain.querySelectorAll('li');

        if(remaining.length >= 2 && remaining[1].getAttribute('data-banner') == key) {
            remaining[1].classList.add('active');
        } else {
            this.refreshStates(key);
        }

    }

    refreshStates(key) {
        var i = 0;
        if(key == 0) {
            while(i < this.banners.length) {
                this.addStateIndicator(true, i, i == 0, false, true);
                i++;
            }
        } else {
            console.log('key - ' + key);

            while (i < this.banners.length - 1) {
                if (i < key) {
                    this.removeRemain(i);

                } else {
                    this.removeInactive(i);
                }

                i++;
            }

            this.addStateIndicator(true, key, true, true, true);
        }
    }

    removeActive(all = false) {
        var active;

        if(all){
            active = this.stateRemain.querySelector('li');
        } else {
            active = this.stateRemain.querySelector('.active');
        }

        if(active){
            active.classList.remove('active');
            active.classList.add('shrink');
            let key = active.getAttribute('data-banner'),
                self = this;

            if(self.banners.length - 1 > key) {
                self.addInactive(key);
            }

            setTimeout(function(){
                active.remove();
            }, 1000)
        }
    }


    removeRemain(key = false) {

        var remainMatch;

        if(key) {
            remainMatch = this.stateRemain.querySelectorAll('[data-banner="' + key + '"]');
        } else {
            remainMatch = this.stateRemain.querySelectorAll('li');
        }

        if(key && this.banners.length - 1 > key) {
            this.addInactive(key);
        }

        if(remainMatch && remainMatch.length) {
            var i = 0;
            while(i < remainMatch.length) {
                let element = remainMatch[i];
                element.classList.add('shrink');

                setTimeout(function(){
                    element.remove();
                }, 300);
                i++;
            }
        }
    }

    removeInactive(key = false) {

        var inactiveMatch;

        if(key) {
            inactiveMatch = this.stateFinished.querySelectorAll('[data-banner="' + key + '"]');
        } else {
            inactiveMatch = this.stateFinished.querySelectorAll('li');
        }

        if(inactiveMatch && inactiveMatch.length) {
            var i = 0;
            while(i < inactiveMatch.length) {
                let element = inactiveMatch[i];
                element.classList.add('shrink');

                setTimeout(function(){
                    element.remove();
                }, 300);
                i++;
            }
        }
    }

    addInactive(key) {
        this.addStateIndicator(false, key, false, false, true);
    }

    showBanner(bannerKey) {
        this.hideBanners();
        this.banners[bannerKey].classList.remove('hidden');

    }

    hideBanners() {
        var i = 0;

        while(i < this.banners.length) {
            this.banners[i].classList.add('hidden');
            i++;
        }
    }

    startLoop(){
        let self = this;
        setTimeout(function(){
            self.itterate(self);
            self.startLoop();
        }, 6000);
    }

    itterate(self) {

        self.removeActive(self.currentBanner);
        self.currentBanner++;

        if(self.currentBanner >= self.banners.length) {
            self.currentBanner = 0;
        }

        self.toggleBanner(self.currentBanner);
    }


    slideDown() {
        window.scrollTo(0, this.banner.offsetHeight);
    }

}


// WEBPACK FOOTER //
// ./assets/sass/front/banner.js